/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'standard-deviation': {
    width: 16,
    height: 27,
    viewBox: '0 0 16 27',
    data: '<g fill-rule="nonzero" _fill="none"><path pid="0" d="M0 3.9h16m-8 0v19.2m-8 0h16" _stroke="#FFF" stroke-width="6" _fill="#000"/><path pid="1" _stroke="#FFF" stroke-width="4" _fill="#FFF" d="M8 8.7l4 4.8-4 4.8-4-4.8z"/><path pid="2" d="M0 3.9h16m-8 0v19.2m-8 0h16" _stroke="#000" stroke-width="2" _fill="#000"/><path pid="3" _fill="#000" d="M8 8.7l4 4.8-4 4.8-4-4.8z"/></g>'
  }
})
